import { getAvailableTabs } from '@/store/fundDetails';
import { useSelector } from 'react-redux';
import FundDetailsTabRow from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabRow';
import AnnualizedTable from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/Tables/AnnualizedTable';
import AnnualizedQuarterlyTable from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/Tables/AnnualizedQuarterlyTable';

const FundDetailsAnnualizedTab = () => {
  const availableTabs = useSelector(getAvailableTabs);
  return (
    <FundDetailsTabRow fullWidth className="mt-4">
      <AnnualizedTable />
      {availableTabs.performanceTab.annualizedQuarterlyTab && (
        <AnnualizedQuarterlyTable className="mt-4" />
      )}
    </FundDetailsTabRow>
  );
};

export default FundDetailsAnnualizedTab;
